/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { buildGetRequest, deleteHandler, stdErrHandlerFactory } from "../../utils/Requests";

import { Blank, Loss, Pagination, Setter } from "../../utils/Interfaces";

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";

export function getMaterialLosses(startDate: string, endDate: string) {
    return buildGetRequest<Pagination<Loss>>(`/api/loss/list/${startDate}/${endDate}`);
}

export function deleteMaterialLoss(lossId: string, dispatch: Dispatch<AnyAction>, setLoading: Setter<boolean>) {
    deleteHandler<Blank>(
        `/api/loss/delete/${lossId}`,
        dispatch,
        (response: AxiosResponse<Blank, any>) => {},
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
